import { TransactionStatus } from '../transfer-mate/index.js';
import { ISummaryIntakes } from '../offer/index.js';
import { EUSSStatus } from '../personal-info/index.js';

export enum TagType {
  OVER_12_MONTHS_UK = 'OVER_12_MONTHS_UK',
  UNDER_12_MONTHS_UK = 'UNDER_12_MONTHS_UK',
  PATHWAY = 'PATHWAY',
  OVER_28_DAYS_VISA_GAP = 'OVER_28_DAYS_VISA_GAP',
  UNDER_28_DAYS_VISA_GAP = 'UNDER_28_DAYS_VISA_GAP',
  EUSS_GRANTED = 'EUSS_GRANTED',
  EUSS_PENDING = 'EUSS_PENDING',
  PROGRAMMABLE = 'PROGRAMMABLE',
  MULTI_INTAKE = 'MULTI_INTAKE',
  MANUAL_CAS = 'MANUAL_CAS',
  AUTOMATION = 'AUTOMATION',
  TRANSFERMATE = 'TRANSFERMATE',
}

export enum TagAction {
  REMOVE = 'REMOVE',
  ADD = 'ADD',
  UPDATE = 'UPDATE',
}

export interface ITagTransferMatePayment {
  transactionId: string;
  initiatedDate: string;
  amount: number;
  currency: string;
}

export interface ITag {
  type?: TagType;
  label: string;
  id: string;
  description?: string;
  manualAction?: TagAction;
  // .manualAction is a field added for programmable tags; user action
  manuallyRemoved?: boolean;
  pathwayUni?: string;
  visaGapExpiryDate?: string;
  visaGapExpiryDays?: number;
  eussStatus?: EUSSStatus;
  multiIntakeTagData?: ISummaryIntakes[];
  /**
   * Used only for system tags.
   */
  removable?: boolean;
  /**
   * TransferMate transaction status
   */
  paymentStatus?: TransactionStatus;
  /**
   * List of TransferMate payments
   */
  payments?: ITagTransferMatePayment[];
}
